/* The registered entry points for the 3D scatter and 3D bubble views.
 *
 * Viewpoint mode only, for the same reason the surface view is - see the note there. */

import { ViewIds } from '@ardoq/api-types';
import styled from 'styled-components';
import { connect } from '@ardoq/rxbeach';
import { toViewpointModeMainViewInstanceId } from 'appLayout/mainViewInstanceIds';
import { getViewpointModeViewSettingsWithChanges$ } from 'views/environmentals/viewSettings/viewpointModeViewSettings$';
import { Points3DView } from './Points3DView';
import { points3dViewModel$ } from './viewModel$/points3dViewModel$';

/** See `Surface3DViewController` for why this grows rather than sets a height. */
const ViewRoot = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

const SCATTER_3D_INSTANCE_ID = toViewpointModeMainViewInstanceId(
  ViewIds.SCATTER_3D
);

const ConnectedScatter3DView = connect(
  Points3DView,
  points3dViewModel$(
    SCATTER_3D_INSTANCE_ID,
    ViewIds.SCATTER_3D,
    false,
    getViewpointModeViewSettingsWithChanges$(
      ViewIds.SCATTER_3D,
      SCATTER_3D_INSTANCE_ID
    )
  )
);

export const Scatter3DViewController = () => (
  <ViewRoot className="prevent-context-change">
    <ConnectedScatter3DView />
  </ViewRoot>
);

const BUBBLE_3D_INSTANCE_ID = toViewpointModeMainViewInstanceId(
  ViewIds.BUBBLE_3D
);

const ConnectedBubble3DView = connect(
  Points3DView,
  points3dViewModel$(
    BUBBLE_3D_INSTANCE_ID,
    ViewIds.BUBBLE_3D,
    true,
    getViewpointModeViewSettingsWithChanges$(
      ViewIds.BUBBLE_3D,
      BUBBLE_3D_INSTANCE_ID
    )
  )
);

export const Bubble3DViewController = () => (
  <ViewRoot className="prevent-context-change">
    <ConnectedBubble3DView />
  </ViewRoot>
);
